<template>
  <div class="textpage">

    <div class="main-content">
      <h1>{{ title }}</h1>
      <p class="excerpt" v-html="greenintro"></p>
      <p v-html="intro"></p>
    </div>

    <div class="video">
      <video controls poster="https://backend.participatiewijzer.nl/wp-content/uploads/2022/07/thumbnail.png">
        <source           
          src="https://backend.participatiewijzer.nl/wp-content/uploads/2022/07/ParticipatieWijzer-ProDemos-subs.mp4" 
          type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>

    <div class="wide-content wide-content--home">
      <div class="space-left">
        <img src="@/assets/home-illustration.svg"/>
      </div>
      <div class="space-right"> 
        <div class="explainer">
          <h1>ParticipatieWijzer</h1>
          <ul>
            <li><span>Stap 1</span> Kies je situatie</li> 
            <li><span>Stap 2</span> Kies een mix van participatiemethoden</li>
            <li><span>Stap 3</span> Kies tips per participatiemethode en sla ze op in je eigen pdf. Bespreek het in je team en ga aan de slag! </li>
          </ul>
          <button @click="onStartClicked" class="button button--wide">Start</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import storage from '../mixins/storage';

const ENDPOINT_NAME = 'ppw/v1/home';
const axios = require('axios');

export default {
  mixins: [
    storage
  ],

  data() {
    return {
      title: '',
      greenintro: '',
      intro: '',
    }
  },
  
  name: "homePage",

  components: {
  },

  methods: {
    onStartClicked() {
      _paq.push(["trackEvent", "userEvent", "toolStarted"]);
      this.$router.push({ path: '/start' });
    },

    // function to retrieve home content from CMS (option fields)
    getHomeContent() {
      const url = new URL(process.env.VUE_APP_REST_URL + ENDPOINT_NAME)

      // fetch(url)
      axios.get(url)
        .then(r => {
          const results = r.data;
          if (!results) {
            this.title = 'HELP, er komen geen data terug!'
          } else {
            this.title = r.data.title;
            this.greenintro = r.data.greenintro;
            this.intro = r.data.intro;
          }
        })
        .catch(error => {
          console.warn(error);
        })
    },
  },

  computed: {
    
  },
  
  created() {
    setTimeout(() => this.getHomeContent())
  },

  mounted() {
    this.clearStorage();
  }
};

</script>

